import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User viewed a library',
  name: 'viewed_library',
  params: [
    {
      description: 'The id of the library',
      name: 'library_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
